<template>
  <v-card flat>
    <v-app-bar
      app
      fade-img-on-scroll
      shrink-on-scroll
      dark
      src="https://www.imperial.ac.uk/ImageCropToolT4/imageTool/uploaded-images/180216_queens_tower_lgbt_month_002--tojpeg_1545305547967_x1.jpg"
      color="#225590"
    >
      <template v-slot:img="{ props }">
        <v-img
          v-bind="props"
          position="center center"
          gradient="to top right, rgba(34,85,144,.9), rgba(34,85,144,.7)"
          alt="bg"
        ></v-img>
      </template>

      <v-layout>
        <v-flex style="font-size:1em">DoCSoc Sponsors Portal</v-flex>
        <v-spacer></v-spacer>
        <SignOut></SignOut>
      </v-layout>

      <template v-slot:extension>
        <v-tabs v-model="activeTab" centered background-color="transparent">
          <v-spacer></v-spacer>
          <v-tab
            :class="$vuetify.breakpoint.xsOnly ? 'subtitle-1' : 'title'"
            style="padding:5px"
          >
            About you
          </v-tab>
          <v-tab
            :class="$vuetify.breakpoint.xsOnly ? 'subtitle-1' : 'title'"
            style="padding:5px"
          >
            Opportunities
          </v-tab>
          <v-tab
            :class="$vuetify.breakpoint.xsOnly ? 'subtitle-1' : 'title'"
            style="padding:5px"
          >
            Account
          </v-tab>
          <v-spacer></v-spacer>
        </v-tabs>
      </template>
    </v-app-bar>

    <v-tabs-items v-model="activeTab">
      <v-tab-item flat>
        <v-container>
          <v-layout justify-center>
            <v-flex xs12 md8>
              <About :Sponsor="sponsor" :syncText="syncText"></About>
            </v-flex>
          </v-layout>
        </v-container>
      </v-tab-item>
      <v-tab-item flat>
        <v-container>
          <v-layout justify-center>
            <v-flex xs12 md8>
              <Opportunities :sponsor="sponsor"></Opportunities>
            </v-flex>
          </v-layout>
        </v-container>
      </v-tab-item>
      <v-tab-item flat>
        <v-container>
          <v-layout justify-center>
            <v-flex xs12 md8>
              <Account :Sponsor="sponsor"></Account>
            </v-flex>
          </v-layout>
        </v-container>
      </v-tab-item>
    </v-tabs-items>
  </v-card>
</template>
<script>
import SignOut from "../components/SignOut";
import Opportunities from "../components/Sponsors/tabs/Opportunities";
import About from "../components/Sponsors/tabs/About";
import Account from "../components/Sponsors/tabs/Account";
import { db } from "../plugins/firebase";

export default {
  fiery: true,
  components: { SignOut, Opportunities, About, Account },
  data: function() {
    return {
      activeTab: 0,
      sponsor: this.$fiery(
        db.collection("Sponsors").doc(this.$store.state.user.uid),
        {
          sub: {
            opportunities: {
              query: opportunities =>
                opportunities.where("deleted", "==", false),
              sub: {
                applications: {}
              }
            }
          }
        }
      )
    };
  },
  methods: {
    syncText(text) {
      this.sponsor.text = text;
      this.$fiery.sync(this.sponsor);
    }
  }
};
</script>
